<script setup>
import { defineProps } from 'vue'
import Row from './Row.vue'

const props = defineProps({
    expandedCriterias: {
        default: Object,
        type: Object
    },
    isActivitiesJob: Boolean,
    mobileView: Boolean
})

function ToggleChilds(parent) {
    parent.show = !parent.show
}
</script>

<template>
    <div class="div-job-activities">
        <div class="div-activity-title">
            <slot name="title"></slot>
        </div>

        <div v-for="activity in props.expandedCriterias" :key="activity.id">
            <div :class="{'div-activity': props.isActivitiesJob, 'div-extra-job': !props.isActivitiesJob, 'div-activity-mobile': mobileView }">
                <Row :element="activity" @toggle-childs="ToggleChilds($event)" :mobile-view="mobileView"/>
            </div>

            <div v-show="activity.show">
                <div class="div-task-container" :class="{'div-task-container-mobile': mobileView}" v-for="task in activity.children" :key="task.id">
                    <div class="div-task" :class="{'div-task-mobile': mobileView}">
                        <Row :element="task" @toggle-childs="ToggleChilds($event)" :mobile-view="mobileView"/>
                    </div>

                    <div v-for="skill in task.children" :key="skill.id">
                        <div class="div-skills-container" v-show="task.show">
                            <div class="div-skill" :class="{'div-skill-mobile': mobileView}">
                                <Row :element="skill"  :mobile-view="mobileView"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.div-activity-title {
    font-weight: bold;
    font-size: 1.2em;
    text-transform: uppercase;
}

.div-task {
    background-color: #405f7b;
}

.div-extra-job,
.div-activity {
    background-color: #3f739f;
    margin-top: 2px;
}

.div-task,
.div-activity,
.div-extra-job,
.div-skill {
    padding: 5px 15px 5px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.div-skill {
    background-color: #2f4a63;
}

.div-activity-mobile,
.div-task-mobile,
.div-skill-mobile {
    padding: 5px!important;
    height: unset !important;
}

.div-task-container,
.div-skills-container {
    padding: 2px 0px 0px 20px;
}

.div-task-container-mobile {
    padding: 2px 0px 0px 10px;
}

@media screen and (max-width: 768px) {

    .div-extra-job,
    .div-activity {
        margin-top: 1px;
    }

    .div-skill {
        padding: 2.5px 5px !important;
    }
    
    .div-skills-container {
        gap: 0px;
        padding-left: 5px;
    }
}

@media screen and (max-width: 468px) {
    .div-activity-title {
        font-size: 1em;
    }
}
</style>